module.exports = __webpack_public_path__ + "static/img/7.b96fee1c.png";